module.exports = __webpack_public_path__ + "img/diapositiva-16-2.742343a3.png";